import React from "react"
import PropTypes from "prop-types"
import { Typography, Box } from "@mui/material"
import CountUp from "react-countup"

import OverviewCard, {
  overviewCardValueSx,
  overviewCardHelperTextSx,
} from "./OverviewCard"
import OverviewMetricChip from "./OverviewMetricChip"
import {
  OVERVIEW_METRIC_ICON_ACCENTS,
  OVERVIEW_METRIC_ICON_PRESETS,
} from "./OverviewMetricIcon"

const MetricCard = ({
  title,
  infoText,
  value,
  symbol,
  rightValue,
  rightSymbol,
  rightChipValue,
  rightChipArrow,
  chipValue,
  accentColor,
  chipArrow,
  helper,
  iconPreset,
  Icon,
  iconAccent,
  loading,
  headerActionHref,
  headerActionTooltip,
}) => {
  const showChipRow = Boolean(chipValue || rightChipValue)
  const showRightValue = rightValue !== undefined && rightValue !== null
  const showFooter = Boolean(helper || showChipRow)

  return (
    <OverviewCard
      iconPreset={iconPreset}
      Icon={Icon}
      iconAccent={iconAccent}
      title={title}
      infoText={infoText}
      loading={loading}
      headerActionHref={headerActionHref}
      headerActionTooltip={headerActionTooltip}
      sx={{ height: "100%" }}
    >
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        sx={{ mb: showFooter ? 0.75 : 0 }}
      >
        <Typography sx={overviewCardValueSx}>
          <CountUp
            end={value}
            duration={1}
            decimals={2}
            decimal=","
            separator="."
            suffix={symbol || ""}
          />
        </Typography>
        {showRightValue && (
          <Typography sx={overviewCardValueSx}>
            <CountUp
              end={rightValue}
              duration={1}
              decimals={2}
              decimal=","
              separator="."
              suffix={rightSymbol || ""}
            />
          </Typography>
        )}
      </Box>
      {helper ? (
        <Typography variant="body2" sx={overviewCardHelperTextSx}>
          {helper}
        </Typography>
      ) : null}
      {showChipRow ? (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mt: helper ? 0.75 : 0 }}
        >
          {chipValue ? (
            <OverviewMetricChip
              accent={accentColor || "default"}
              arrow={chipArrow}
            >
              {chipValue}
            </OverviewMetricChip>
          ) : (
            <div />
          )}
          {rightChipValue ? (
            <OverviewMetricChip
              accent={accentColor || "default"}
              arrow={rightChipArrow}
            >
              {rightChipValue}
            </OverviewMetricChip>
          ) : null}
        </Box>
      ) : null}
    </OverviewCard>
  )
}

MetricCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  infoText: PropTypes.string,
  symbol: PropTypes.string,
  rightValue: PropTypes.number,
  rightSymbol: PropTypes.string,
  rightChipValue: PropTypes.string,
  rightChipArrow: PropTypes.string,
  chipValue: PropTypes.string,
  accentColor: PropTypes.string,
  chipArrow: PropTypes.string,
  helper: PropTypes.string,
  iconPreset: PropTypes.oneOf(Object.keys(OVERVIEW_METRIC_ICON_PRESETS)),
  Icon: PropTypes.elementType,
  iconAccent: PropTypes.oneOf(OVERVIEW_METRIC_ICON_ACCENTS),
  loading: PropTypes.bool,
  headerActionHref: PropTypes.string,
  headerActionTooltip: PropTypes.string,
}

MetricCard.defaultProps = {
  loading: false,
}

export default MetricCard
